<template>
  <div class="pb1">
    <CRGlobalSelector/>
    <!-- report body -->
    <div v-if="showReportBody">
      <div class="dt w-100">
        <div class="dtr">
          <div class="dtc w-100 v-mid">
            <h3 class="compareByFilterTitle">
              <template v-if="printerFriendly">
                Disability and Health Data System
                <br>
              </template>
              Compare By: {{ compareByLabel }}
              <template
                v-if="locationLabel">
                <br>
                Location: {{ locationLabel }}
              </template>
              <template v-if="printerFriendly && !locationLabel">
                <br>&nbsp;
              </template>
            </h3>
          </div>
          <div
            v-if="printerFriendly"
            class="dtc">
            <img
              class="pflogo"
              src="../../assets/Shared.Images.hhs-cdc-logo.png"
              alt="CDC logo">
          </div>
        </div>
      </div>
      <CRSearchBar/>
      <CRRemoveModal
        @modalClosed="removeModalClosed"
      />
      <CRReportOptions/>
      <div
        v-if="!printerFriendly"
        class="expandCollapse"
        style="margin-bottom: 5px;">
        <a
          href="#"
          @click.prevent="expandAll">Expand All</a>
        <a
          href="#"
          @click.prevent="collapseAll">Collapse All</a>
      </div>
      <div
        :class="{'w-100': categoriesShownCount === 0}"
        class="categoryTable">
        <div
          v-for="category in categoriesFiltered"
          :key="category.id"
          class="dtr" >
          <div
            class="categoryCell">
            <h4 class="categoryLink">
              <a
                v-if="!printerFriendly"
                :id="`lnk_${category.id}`"
                href="#"
                @click.prevent="setShowCategoryId(category.id, !showCategoryIds[category.id])"
              >{{ showCategoryIds[category.id] ? '-' : '+' }} Category: {{ category.name }}</a>
              <!-- {{ searchHitsForCategory(category.id) }} -->
              <span v-else>
                {{ showCategoryIds[category.id] ? '-' : '+' }} Category: {{ category.name }}
              </span>
            </h4>
            <div
              :class="{dn: !showCategoryIds[category.id]}"
              class="bgwhite">
              <CRTable
                :cat-data="rowsForCategory(category.id)"
                :category-id="category.id"
              />
              <CRDebugTable
                v-if="showDebugIds"
                :cat-data="rowsForCategory(category.id)"
              />
            </div>
          </div>
        </div>
      </div>
      <CRPanelFootnotes/>
      <PageFootnotes/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
// import api from '../../api';
// import helper from '../../helper';
import CRGlobalSelector from './CRGlobalSelector';
import CRSearchBar from './CRSearchBar';
import CRReportOptions from './CRReportOptions';
import CRTable from './CRTable';
import CRDebugTable from './CRDebugTable';
import CRRemoveModal from './CRRemoveModal';
import CRPanelFootnotes from './CRPanelFootnotes';
import PageFootnotes from '../common/PageFootnotes';
// import PageFootnotes from './PageFootnotes';

export default {
  components: {
    CRGlobalSelector,
    CRSearchBar,
    CRReportOptions,
    CRTable,
    CRDebugTable,
    CRRemoveModal,
    CRPanelFootnotes,
    PageFootnotes,
  },
  computed: {
    ...mapState({
      lku: state => state.lku,
      showReportBody: state => state.CR.flags.showReportBody,
      GSGo: state => state.CR.GSGo,
      showCategoryIds: state => state.CR.showCategoryIds,
      reportType: state => state.CR.GSGo.reportType,
      showDebugIds: state => state.flags.showDebugIds,
    }),
    crDataFiltered() {
      return this.$store.getters['CR/crDataFiltered'];
    },
    categoriesFiltered() {
      return this.$store.getters['CR/categoriesFiltered'];
    },
    printerFriendly() {
      return this.$store.getters.printerFriendly;
    },
    compareByLabel() {
      if (this.reportType === 'Locations') return 'Location';
      if (this.reportType === 'Demographics') return this.lku.StratificationCategory[this.GSGo.stratCatId].name;
      if (this.reportType === 'Years') return 'Year';
      throw new Error(`Unknown reportType: ${this.reportType}`);
    },
    locationLabel() {
      return this.reportType !== 'Locations' ? this.lku.Location[this.GSGo.locationId].name : '';
    },
    categoriesShownCount() {
      return _(this.categoriesFiltered)
        .reduce((acc, obj) => (acc + this.showCategoryIds[obj.id] ? 1 : 0), 0);
    },
  },
  created() {
    if (this.printerFriendly) {
      // disable max-width rule for body set in app.css
      document.body.className = 'no-max-width';
    }
  },
  methods: {
    setShowCategoryId(categoryId, show) {
      this.$store.commit('CR/setShowCategoryId', { id: categoryId, show });
      this.$store.dispatch('CR/setBrowserUrlBarToReflectCurrentCRState', this.$router);
    },
    rowsForCategory(categoryId) {
      return _(this.crDataFiltered).filter({ c: categoryId }).value();
    },
    searchHitsForCategory(categoryId) {
      return this.$store.getters['CR/searchHitsForCategory'](categoryId);
    },
    removeModalClosed(categoryId) {
      // console.log('removeModalClosed', categoryId);
      document.getElementById(`lnk_${categoryId}`).focus({ preventScroll: true });
    },
    expandAll() {
      const newShowCategoryIds = _(this.categoriesFiltered).reduce((acc, obj) => {
        acc[obj.id] = true;
        return acc;
      }, {});
      this.$store.commit('CR/setShowCategoryIds', newShowCategoryIds);
      this.$store.dispatch('CR/setBrowserUrlBarToReflectCurrentCRState', this.$router);
    },
    collapseAll() {
      const newShowCategoryIds = _(this.categoriesFiltered).reduce((acc, obj) => {
        acc[obj.id] = false;
        return acc;
      }, {});
      this.$store.commit('CR/setShowCategoryIds', newShowCategoryIds);
      this.$store.dispatch('CR/setBrowserUrlBarToReflectCurrentCRState', this.$router);
    },
  },
};
</script>

<style scoped>
  .categoryTable {
    display: table;
    border-collapse: collapse;
  }

  .dtr {
    display: table-row;
  }

  .categoryCell {
    border: 1px solid rgb(128, 128, 128);
    display: table-cell;
    background-color: #F1F0F0;
    /* border-top: 1px solid rgb(128, 128, 128);
    border-right: 1px solid rgb(128, 128, 128);
    border-left: 1px solid rgb(128, 128, 128); */
  }
  .categoryLink {
    font-size: 16px;
    margin: 5px;
  }

  .bgwhite {
    background-color: white;
  }

  div.expandCollapse a + a {
    padding-left: 10px;
  }
</style>

<style>
  body.no-max-width {
    max-width: none;
  }

  .dn {
    display: none;
  }

  .dt {
    display: table;
  }

  .dtc {
    display: table-cell;
  }

  .w-100 {
    width: 100%;
  }

  .v-mid {
    vertical-align: middle;
  }

  .pt1 {
    padding-top: .25rem;
  }

  .pb1 {
    padding-bottom: .25rem;
  }

  .compareByFilter {
    padding: 4px 4px 4px 4px;
    background-color: #F1F0F0;
    height: auto;
    border: solid 1px #d7d9dd;
    margin-bottom: 10px;
  }

  .compareByFilterTitle {
    font-size: 20px;
    line-height: 30px;
    -webkit-margin-before: 0;
    -webkit-margin-after: 0;
  }

  .compareByFilterElements {
    padding: 0 4px 0 4px;
    display: table-cell;
    vertical-align: middle;
    white-space: nowrap;
  }

  .compareByFilterSearch {
    padding: 0 4px 0 14px;
    display: table-cell;
    vertical-align: middle;
    white-space: nowrap;
  }

  div.compareByFilterCol {
    height: 50px;
    display: table;
  }

  div.compareByFilterColExp {
    height: 70px;
    display: table;
  }

  div.NestedExp {
    height: 25px;
    display: table;
  }

  .exportLogo {
    padding: 0 4px 0 4px;
    display: table-cell;
    vertical-align: middle;
    text-align: right;
  }

  .exportLogoCSV {
    padding: 0 8px 0 4px;
    display: table-cell;
    vertical-align: middle;
    text-align: right;
  }

  .exportText {
    padding: 0 4px 6px 3px;
    display: table-cell;
    vertical-align: middle;
    text-align: left;
    white-space: nowrap;
  }

  .optionsHeader {
    background-color: #084239;
    color: white;
    font-size: 1.2em;
    margin-top: 0px;
    padding: 0 0 0 8px;
    text-align: center;
  }

  .divSpacer {
    margin: 5px 5px 5px 5px;
  }

  .optionsContainer {
    border: solid 1px #084239;
    background-color: #C1DED5;
    height: 155px;

  }

  .optionsElement {
    padding: 4px 4px 4px 8px;
  }

  .textElement {
    line-height: 1.5;
  }

  label.checkbox-label input[type=checkbox] {
    position: relative;
    vertical-align: middle;
    bottom: -2px;
  }


  label.radio-label input[type=radio] {
    position: relative;
    vertical-align: middle;
    bottom: 3px;
  }

  .updateBtn {
    text-align: right;
    padding: 4px 8px 8px 8px;
  }

  .hideBtn {
    text-align: left;
    vertical-align: middle;
    padding: 10px 4px 4px 8px;
  }

  .search-col {
    text-align: center;
  }

  .highlight {
      background-color: yellow;
      margin:inherit;
      padding: inherit;
  }

  .search {
    padding:1px 2px 1px 6px;
  }

  .align-left {
    float: left;
  }
  .align-right {
    float: right;
  }

  .align-clear{
    clear: both;
  }

  .showHideLink {
    display: inline-block;
    width: 94px;
  }

  .highlight {
      background-color: yellow;
      margin: inherit;
      padding: inherit;
  }
</style>




// WEBPACK FOOTER //
// src/components/CR/ComparisonReport.vue